import { colorsPalettes } from "@similarweb/styles";

import { translate } from "app/filters/i18nFilter";

export const DEFAULT_UN_CHECK_COLOR = colorsPalettes.carbon[200];
export const INITIAL_SELECTION = 5;
export const MAX_SELECTION = 10;
export const getOthersDomainName = () => translate("common.others");
export const MIN_DOMAINS_FOR_OTHERS_DISPLAY = 5;
